import React, { createElement, ComponentClass, Component } from 'react';
import Dialog from 'react-dialog';
import 'react-dialog/css/index.css';
import withStyles, { WithStyles } from 'react-jss';
import { store } from '../store';
import { flowRight } from 'lodash';
import { observer } from 'mobx-react';

const styles = {
    header: {
        margin: 10,
    },
    dialog: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
};

interface IProps extends WithStyles<typeof styles> {}

const DialogElement: React.FunctionComponent<IProps> = ({ classes }) => (
    <div>
        {store.ui.isConfirmationBoxOpen ? (
            <Dialog
                title={store.ui.dialogTitle}
                onClose={() => (store.ui.isConfirmationBoxOpen = false)}
                modal={true}
                buttons={[
                    {
                        text: 'Yes',
                        onClick: () => store.ui.onDialogResponded(true),
                    },
                    {
                        text: 'No',
                        onClick: () => store.ui.onDialogResponded(false),
                    },
                ]}>
                <div className={classes.dialog}>
                    <span className={classes.header}>{store.ui.dialogContent}</span>
                </div>
            </Dialog>
        ) : null}

        {store.ui.isHelpOpen ? (
            <Dialog
                title={store.ui.dialogTitle}
                onClose={() => (store.ui.isHelpOpen = false)}
                modal={true}
                buttons={[
                    {
                        text: 'Visit this site',
                        onClick: () => window.open(''),
                    },
                ]}>
                <div className={classes.dialog}>
                    <span className={classes.header}>{store.ui.dialogContent}</span>
                </div>
            </Dialog>
        ) : null}

        {store.ui.isMailConfirmationDialogOpen ? (
            <Dialog title="Mail Confirmation" onClose={() => (store.ui.isMailConfirmationDialogOpen = false)} modal={true} buttons={[]}>
                <div className={classes.dialog}>
                    <span className={classes.header}>Mail Sent Successfully!!</span>
                </div>
            </Dialog>
        ) : null}
    </div>
);

export default flowRight([withStyles(styles), observer])(DialogElement);

// modal types
// Help => 0, Delete Confirm => 1, Mail Acknowledgement => 2, Preiew => 3, Save As => 4
export function openDialog(title, content, type): Promise<boolean> {
    switch (type) {
        case 0:
            store.ui.isHelpOpen = true;
            break;
        case 1:
            store.ui.isConfirmationBoxOpen = true;
            break;
    }

    return new Promise(function(res) {
        store.ui.dialogTitle = title;
        store.ui.dialogContent = content;
        store.ui.onDialogResponded = function(userAction) {
            if (!userAction) {
                store.ui.isConfirmationBoxOpen = false;
            }
            res(userAction);
        };
    });
}
